module.exports = __webpack_public_path__ + "static/media/pictogram-sprite-sheet.ca9535e9.svg";